import React, { useEffect, useState, useContext, Fragment, useRef } from "react";
import {useForm} from 'react-hook-form';

import Contexto from '../comun/Contexto';
import Pagina, {buscarPagina, esMayorOIgualACero} from "../comun/Pagina";
import SelectReactHookForm from "../comun/SelectReactHookForm";
import CPSMapa from "./CPSMapa";
import CPSTabla from "./CPSTabla";
import CPSSelectorCP from "./CPSSelectorCP";

export const NAV_CONSULTA_SITIO_SEL_CP = "NAV_CONSULTA_SITIO_SEL_CP";
export const NAV_CONSULTA_SITIO_MAPA = "NAV_CONSULTA_SITIO_MAPA";
export const NAV_CONSULTA_SITIO_TABLA = "NAV_CONSULTA_SITIO_TABLA";

const ConsultaPorSitio= (props) => {
    /** Estado */
    const [idPagina, setIdPagina] = useState(NAV_CONSULTA_SITIO_SEL_CP);           
    const [idCP, setIdCP] = useState(-1);    

    /** refs */    
    const nombreMunRef = useRef(null);
    const nombreCPRef = useRef(null);

    //** Navegacion */
    const irAConsultaSelCP = () => {
        setIdPagina(NAV_CONSULTA_SITIO_SEL_CP);
    }

    const irAConsultaTabla = () => {
        setIdPagina(NAV_CONSULTA_SITIO_TABLA);
    }

    const irAConsultaMapa = () => {        
        setIdPagina(NAV_CONSULTA_SITIO_MAPA);
    }

    const paginas =[
        {id:NAV_CONSULTA_SITIO_SEL_CP, componente: <CPSSelectorCP                
        idCP={idCP} setIdCP={setIdCP} 
        nombreMunRef={nombreMunRef} nombreCPRef={nombreCPRef}
        irAPagina0={props.irAPagina0}  irAConsultaTabla={irAConsultaTabla} 
        />
        },
        {id:NAV_CONSULTA_SITIO_TABLA, componente: <CPSTabla 
        nombreMunRef={nombreMunRef} nombreCPRef={nombreCPRef}    
        idCentroPoblado={idCP}
        irAConsultaSelCP ={irAConsultaSelCP} irAConsultaMapa={irAConsultaMapa} />
        },
        {id:NAV_CONSULTA_SITIO_MAPA, componente: <CPSMapa
        nombreMunRef={nombreMunRef} nombreCPRef={nombreCPRef}    
        idCentroPoblado={idCP}
        irAConsultaSelCP ={irAConsultaSelCP} irAConsultaTabla ={irAConsultaTabla}
        />}
    ];
   
    return (        
        buscarPagina(idPagina, paginas)
    )   
}
export default ConsultaPorSitio;

export const PanelInfoSitio =({nombreMunRef,nombreCPRef }) =>{
    return (
        <div className="ConsultaPorSitioTituloTabla">
            SITIO: {nombreMunRef.current}, {nombreCPRef.current}
        </div>
    );
}